import React from "react";
import Content from "../../components/Content";

export const RegistryView = () => {
  return (
    <>
      <Content title={"Register"}>
        <div className="container">Hur hittade du hit?</div>
      </Content>
    </>
  );
};
